import React from 'react';
import { Type } from '../../../types';
import {
    StyledDialogContent,
    DialogTitle,
    CloseButton,
    FlexWrapper
} from '../Dialogs.styles';
import { SmallBanner } from './Ads/SmallBanner';
import { BigBanner } from './Ads/BigBanner';
import { Video } from './Ads/Video';
import { Poll } from './Ads/Poll';
import { PreviewProps } from './Preview.interface';
import { Wrapper, StyledDialog } from './Preview.styles';

export function Preview({ open, setOpen, image, imageMobile, video, adType, pollCreate, pollDetails}: PreviewProps) {
    const renderAd = (type: string) => {
        switch (type) {
            case Type.SmallBanner:
                return <SmallBanner image={image} />;
            case Type.BigBanner:
                return <BigBanner image={image} imageMobile={imageMobile} />;
            case Type.Poll:
                return <Poll image={image} dataCreate={pollCreate} dataDetails={pollDetails} />;
            case Type.Video:
                return <Video video={video} />;
            default:
                return null;
        }
    }
    return (
        <StyledDialog
            open={open}
            onClose={() => setOpen(false)}
        >
            <StyledDialogContent>
                <DialogTitle>Campaign preview</DialogTitle>
                <Wrapper>
                    {renderAd(adType)}
                </Wrapper>
                <FlexWrapper><CloseButton onClick={() => setOpen(false)}>Close window</CloseButton></FlexWrapper>
            </StyledDialogContent>
        </StyledDialog>
    )
}
